import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const microBenefits = [{
    emoji: '📘',
    text: '6 tomos'
  }, {
    emoji: '🎁',
    text: '6 bonos'
  }, {
    emoji: '📄',
    text: 'PDF'
  }, {
    emoji: '⚡',
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-3 pb-8 sm:pt-6 sm:pb-12 md:pt-12 md:pb-20 overflow-hidden bg-navy-900 border-b border-white/5" data-id="element-103">
      {/* Subtle dot pattern */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" data-id="element-104">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, rgba(201,168,76,0.5) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-105" />
      </div>

      {/* Soft gold radial glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[900px] h-[700px] bg-gold/[0.07] blur-[120px] rounded-full pointer-events-none" data-id="element-106"></div>

      {/* Top brand bar */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-3 sm:mb-5 md:mb-8" data-id="element-107">
        <div className="flex items-center justify-center sm:justify-between" data-id="element-108">
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="flex items-center gap-1.5" data-id="element-109">
            <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full border border-gold/40 flex items-center justify-center text-gold text-[10px]" data-id="element-110">
              🩺
            </div>
            <span className="font-editorial text-gold text-xs sm:text-base tracking-wide" data-id="element-111">
              Atlas Clínico
            </span>
          </motion.div>
        </div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center" data-id="element-112">
        {/* Trust line */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-1.5 mb-2.5 sm:mb-4" data-id="element-113">
          <div className="flex gap-0.5" data-id="element-114">
            {[...Array(5)].map((_, i) => <Star key={i} size={11} className="fill-gold text-gold sm:w-3 sm:h-3" data-id="element-115" />)}
          </div>
          <span className="text-[11px] sm:text-sm text-gray-300 font-medium" data-id="element-116">
            <span className="text-white font-bold" data-id="element-117">4.9/5</span> · +300
            estudiantes
          </span>
        </motion.div>

        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-gold/30 bg-gold/5 text-gold text-[9px] sm:text-xs font-bold tracking-[0.12em] uppercase mb-3 sm:mb-5 max-w-[280px] sm:max-w-md leading-tight" data-id="element-118">
          <span className="w-1 h-1 rounded-full bg-gold animate-pulse flex-shrink-0" data-id="element-119"></span>
          <span data-id="element-120">Evaluación traumatológica y musculoesquelética</span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="font-heading font-extrabold text-white leading-[0.92] tracking-tight mb-3 sm:mb-5" data-id="element-121">
          <span className="block text-[2.25rem] sm:text-6xl md:text-7xl lg:text-[6.5rem]" data-id="element-122">
            MEGA PACK
          </span>
          <span className="block text-[1.875rem] sm:text-5xl md:text-6xl lg:text-[5.5rem] text-transparent bg-clip-text bg-gradient-to-r from-gold-light via-gold to-gold-light" data-id="element-123">
            KINESIOLOGÍA
          </span>
        </motion.h1>

        {/* PRODUCT MOCKUP — compact, below headline */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.6,
        ease: 'easeOut'
      }} className="relative flex justify-center mb-3 sm:mb-5 w-full" data-id="element-124">
          <div className="relative w-full max-w-[280px] sm:max-w-[380px] md:max-w-[460px]" data-id="element-125">
            <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full scale-75 pointer-events-none" data-id="element-126"></div>
            <div className="absolute inset-0 bg-navy-500/30 blur-[60px] rounded-full scale-90 pointer-events-none" data-id="element-127"></div>

            <motion.img src="https://cdn.magicpatterns.com/uploads/oGvgXBXVGL78eTMFH1YLiL/Diseno_sin_titulo_(3).png" alt="Mega Pack Kinesiología — Sistema de Evaluación Clínica" className="relative w-full drop-shadow-[0_20px_50px_rgba(0,0,0,0.7)]" animate={{
            y: [0, -6, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-128" />
          </div>
        </motion.div>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-sm sm:text-lg md:text-2xl text-white font-medium mb-2 sm:mb-4 max-w-3xl leading-snug px-2" data-id="element-129">
          Aprendé a evaluar con criterio, usar los{' '}
          <span className="font-editorial italic text-gold font-normal" data-id="element-130">
            tests correctos
          </span>{' '}
          y dejar de improvisar frente al paciente.
        </motion.p>

        {/* Support paragraph */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="text-[11px] sm:text-sm md:text-base text-gray-400 mb-3 sm:mb-6 max-w-2xl leading-relaxed px-2" data-id="element-131">
          6 tomos + 6 bonos en PDF para estudiar, practicar y consultar
          anamnesis, pruebas ortopédicas, diagnóstico diferencial, red flags y
          razonamiento clínico{' '}
          <span className="font-editorial italic text-gold/90" data-id="element-132">
            en un solo sistema.
          </span>
        </motion.p>

        {/* Microbenefits */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="flex flex-wrap justify-center items-center gap-x-2 sm:gap-x-3 gap-y-1 mb-4 sm:mb-6" data-id="element-133">
          {microBenefits.map((benefit, idx) => <Fragment key={idx} data-id="element-134">
              <div className="flex items-center gap-1 text-[10px] sm:text-sm text-white/90" data-id="element-135">
                <span data-id="element-136">{benefit.emoji}</span>
                <span className="font-medium" data-id="element-137">{benefit.text}</span>
              </div>
              {idx < microBenefits.length - 1 && <span className="text-gray-600 text-[10px] sm:text-sm" data-id="element-138">·</span>}
            </Fragment>)}
        </motion.div>

        {/* Primary CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.45
      }} className="flex justify-center w-full mb-4 sm:mb-6" data-id="element-139">
          <a href="#pricing" className="group inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-hover text-navy-950 font-bold text-sm sm:text-lg px-6 sm:px-10 py-3.5 sm:py-5 rounded-full transition-all transform hover:scale-[1.02] shadow-[0_0_50px_rgba(201,168,76,0.35)] w-full max-w-[320px] sm:max-w-none sm:w-auto" data-id="element-140">
            QUIERO MI MEGA PACK AHORA
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-141" />
          </a>
        </motion.div>

        {/* Trust/payment badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.55
      }} className="flex flex-wrap justify-center items-center gap-x-3 sm:gap-x-4 gap-y-1.5 text-[10px] sm:text-sm text-gray-400" data-id="element-142">
          <div className="flex items-center gap-1" data-id="element-143">
            <ShieldCheck size={12} className="text-green-400 flex-shrink-0 sm:w-3.5 sm:h-3.5" data-id="element-144" />
            <span data-id="element-145">Garantía 7 días</span>
          </div>
          <span className="text-gray-600" data-id="element-146">·</span>
          <div className="flex items-center gap-1" data-id="element-147">
            <Lock size={12} className="text-green-400 flex-shrink-0 sm:w-3.5 sm:h-3.5" data-id="element-148" />
            <span data-id="element-149">Pago seguro</span>
          </div>
          <span className="text-gray-600" data-id="element-150">·</span>
          <div className="flex items-center gap-1" data-id="element-151">
            <CreditCard size={12} className="text-blue-400 flex-shrink-0 sm:w-3.5 sm:h-3.5" data-id="element-152" />
            <span data-id="element-153">Mercado Pago</span>
          </div>
        </motion.div>
      </div>
    </section>;
}